//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'depositGood',

  data() {
    return {

    }
  },
  computed: {

  },
  props: {
    goodInfo: {
      type: Object,
      value: null,
    },
    skus0: {
      type: Object,
      value: null,
    },
    minLadderPrice: {
      type: Object,
      value: null,
    },
    goods: {
      type: Object,
      value: null,
    },
    isCycle:{
      type: Boolean,
      value: false,
    },
    staticDomain:{
      type: String,
      value: false,
    }
  },
  methods: {
    splitFun: function(str, sign, num) {
      if (str != undefined) {
        str = str.toString();
        let arr = str.split(sign);
        if (arr.length > num) {
          return arr[num];
        } else {
          return "00";
        }
      }
      return "";
    },
    strLengthFun: function(str) {
      if (str != undefined) {
        let num = str.length;
        return num;
      }
      return 0;
    },

  },
  created() {

  }
}



// WEBPACK FOOTER //
// ./src/components/goodDetail/depositGood.vue